"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputPassword = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _objectSpread2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _react = _interopRequireWildcard(require("react"));
var _Input = require("../input/Input");
var _Button = require("../button/Button");
var _password = require("../../utils/password/password");
var _inputPasswordModule = _interopRequireDefault(require("./input-password.module.scss"));
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var _excluded = ["passwordToggle"];
var defaultProps = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _Input.Input.defaultProps), {}, {
  meta: {},
  passwordToggle: false
});
var InputPassword = function InputPassword(props) {
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var passwordToggle = props.passwordToggle,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showPassword = _useState2[0],
    setShowPassword = _useState2[1];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _inputPasswordModule.default['input-wrapper']
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, Object.assign({}, rest, {
    type: showPassword ? 'text' : 'password',
    autoComplete: "off",
    pattern: _password.PASSWORD_REGEX
  })), passwordToggle && /*#__PURE__*/_react.default.createElement(_Button.StandardButton, {
    "aria-hidden": true,
    onClick: function onClick(evt) {
      evt.persist();
      console.warn('HELLO?');
      setShowPassword(function (prevState) {
        return !prevState;
      });
    },
    className: _inputPasswordModule.default['toggle-button']
  }, showPassword ? /*#__PURE__*/_react.default.createElement("span", null, t('inputPassword.hide')) : /*#__PURE__*/_react.default.createElement("span", null, t('inputPassword.show'))));
};
exports.InputPassword = InputPassword;
InputPassword.defaultProps = defaultProps;
InputPassword.displayName = 'InputPassword';